export var GlobalEntities;
(function (GlobalEntities) {
    GlobalEntities["Accounts"] = "accounts";
    GlobalEntities["DynamicSnippets"] = "dynamicSnippets";
    GlobalEntities["Partners"] = "partners";
    GlobalEntities["SecurityFactor"] = "securityFactors";
    GlobalEntities["Settings"] = "settings";
    GlobalEntities["Teams"] = "teams";
    GlobalEntities["Users"] = "users";
    GlobalEntities["AccountAssignments"] = "accountAssignments";
})(GlobalEntities || (GlobalEntities = {}));
//# sourceMappingURL=global-entities.js.map